module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-end wrapper mt-5 pb-3"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 d-none d-sm-block"
  }, [_c('img', {
    staticClass: "img-fluid rounded",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-9 align-self-center"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('img', {
    staticClass: "kotori img-fluid rounded col-4 d-block d-sm-none d-md-none d-lg-none",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mt-2 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center align-self-center"
  }, [_vm._v(_vm._s(_vm.$t('about')))])]), _vm._v(" "), _c('div', {
    staticClass: "row form-pc"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('runBy'))
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('aware')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('p1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('p2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('p3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('p4')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('p5')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f343f5f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/about.vue
// module id = 44
// module chunks = 0